import { Grid, PasswordInput } from '@mantine/core';
import type { UseFormReturnType } from '@mantine/form';
import { IconTextCaption } from '@tabler/icons-react';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';

interface PasswordInputProps {
	form: UseFormReturnType<any, (values: any) => any>;
	inline?: boolean;
}

export function PasswordInputs({ form, inline = false }: PasswordInputProps) {
	return (
		<>
			<Grid.Col span={inline ? 6 : 12}>
				<PasswordInput
					label={'Password'}
					placeholder={'Insert password...'}
					leftSection={<IconTextCaption {...defaultIconStyle} />}
					key={form.key('password')}
					{...form.getInputProps('password')}
					data-cy="password-input"
				/>
			</Grid.Col>
			<Grid.Col span={inline ? 6 : 12}>
				<PasswordInput
					label={'Confirm Password'}
					placeholder={'Confirm password...'}
					leftSection={<IconTextCaption {...defaultIconStyle} />}
					key={form.key('checkPassword')}
					{...form.getInputProps('checkPassword')}
					data-cy="checkPassword-input"
				/>
			</Grid.Col>
		</>
	);
}
